import React from "react";
import "./new_admission.css";
import "../../page_content.css";
import { useNavigate } from "react-router-dom";
import CommonCards from "../../../components/reuseable_comp/common_cards/CommonCards";

const NewAdmission = () => {
  const navigate = useNavigate();

  const cardsData = [
    {
      logo: "/assets/images/icons/stethoscope.webp",
      title: "DG Approved Doctors list ",
      link: "https://drive.google.com/file/d/1yrCFHHEG5RNRqOpuNBtZzzbaUbAJfrOH/view?usp=drive_link",
    },
    {
      logo: "/assets/images/icons/satisfaction.webp",
      title: "Eligibility Criteria For Programs",
      link: "/admissions/course-eligibilty",
    },
    {
      logo: "/assets/images/icons/solved.webp",
      title: "Admission Procedure Queries",
      link: "/admissions/admission-faq",
    },
  ];

  return (
    <div>
      <h1 className="title">Admission Open for the A.Y. 2026-27</h1>

      <div className="page-content-container">
        <div className="new-adminssion-container">
          {/* section 1 */}
          <div className="new-adminssion-cards">
            <div className="admission-card-top">
              <h3 className="accordion-title">
                Admission Open for First Year to B. Tech Marine Engineering (4
                Yrs) / B. Sc. Nautical Science (3 yrs) 
              </h3>
            </div>

            <div className="admission-card-content">
              <p style={{color:"blue"}}> Diploma in Nautical Science (1 Yrs) forms closed</p>
              <h4 className="innerpage-subheading">Note :</h4>
              <ul className="admission-lists">
                <li>Candidates must have a valid passport at the time of admission.</li>
                <li>Qualifying IMU CET/State level Engineering Entrance Exam/JEE (with more than 40 Percentile) is mandatory for First Year B. Tech Marine Engineering, B.Sc. Nautical Science admission</li>
                <li>Qualifying IMU CET is mandotary for Diploma in Nautical Science.</li>
                <li> Part time or distance learning or correspondence course or any combination of these shall not be considered.</li>
              </ul>



              <div className="new-admission-note">
                <h4 className="innerpage-subheading">
                  Note- (For Existing user) :
                </h4>
                <p>
                  1.Login details are available on your registered email and
                  Mobile No.
                  <br />
                  2.The Application Fee for Registration is Non-Refundable
                </p>
              </div>

              <b> Apply From Desktop / PC:</b>
              <button
                className="new-adm-btn"
                onClick={() => navigate("/admissions/application-form")}
              >
                Apply Now
              </button>
            </div>
          </div>

          {/* section 2 */}
          <div className="new-adminssion-cards">
            <div className="admission-card-top">
              <h3 className="accordion-title">
                Application for Electro Technical Officer (4 Months)
              </h3>
            </div>

            <div className="admission-card-content">
              <h4 className="innerpage-subheading">Note:</h4>
              <ul className="admission-lists ">
                <li> Having passport at the time of admission is mandatory.</li>
              </ul>

              <div className="new-admission-note">
                <h4 className="innerpage-subheading">
                  Note- (For Existing user) :
                </h4>
                <p>
                  1.Login details are available on your registered email and
                  Mobile No.
                  <br />
                  2.The Application Fee for Registration is Non-Refundable
                </p>

              </div>

              <b> Apply From Desktop / PC:</b>
              <button
                className="new-adm-btn"
                onClick={() => navigate("/admissions/application-form")}
              >
                Apply Now
              </button>
            </div>
          </div>

          {/* section 3 */}
          <div className="new-adminssion-cards">
            <div className="admission-card-top">
              <h3 className="accordion-title">
                Applications are closed for Direct 2nd Year (Lateral Entry) to
                B. Tech Marine Engineering (4 Yrs)
              </h3>
            </div>

            {/* <div className="admission-card-content">
              <h4 className="innerpage-subheading">Note :</h4>
              <ul className="admission-lists ">
                <li>Having passport at the time of admission is mandatory.</li>
              </ul>

              <div className="new-admission-note">
                <h4 className="innerpage-subheading">
                  Note - (For Existing user) :
                </h4>
                <p>
                  Login details are available on your registered email and
                  Mobile No.
                </p>
              </div>

              <b> Apply From Desktop / PC:</b>
          <button
  className="new-adm-btn"
  onClick={() => window.open("https://www.digialm.com//EForms/configuredHtml/176/69589/Registration.html", "_blank")}
>
  Click Here
</button>
            </div> */}
          </div>
        </div>

        <div>
          <div className="common-cards-container">
            {cardsData.map((card, index) => (
              <div className="common-cards" key={index}>
                <img src={card.logo} alt={card.title} />

                <h1 className="common-cards-title" style={{ fontSize: "clamp(12px, 1.3vw, 22px)" }}>{card.title}</h1>
                <br />
                <a
                  href={card.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="page-content-btn"
                  style={{ padding: "10px" }}
                >
                  View More
                </a>
              </div>
            ))}
          </div>
          <div className="page-content-note">
            <p>
              For Admission Details Contact on :
              <a href="tel:+917774062353"> +91-9595996611 </a>
            </p>

            <p>
              Connect with us on WhatsApp:
              <a
                href="https://wa.me/91918308010405"
                target="_blank"
                rel="noopener noreferrer"
              >
                +91-918308010405
              </a>
            </p>
          </div>
        </div>
      </div>
    </div >
  );
};

export default NewAdmission;
